module.exports = __webpack_public_path__ + "static/buttonAriaRole-fb5cd97f69865f25f2623901bc976899.png";